"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@app/_context";
import Link from "next/link";

export const NewCustomerHeader = ({
  onClose,
}: {
  onClose?: () => void;
}) => {
  const t = useTranslate();
  const { locale } = useMarket().state.market;
  return (
    <div className="flex max-w-72 flex-col">
      <h2 className="text-lg">{t("newCustomerFormHeading")}</h2>

      <p className="mb-6 mt-3 flex-1 text-base">
        {t("newCustomerFormInfoText")}
      </p>
      <p className="text-sm">
        {" "}
        {t("newCustomerFormTermsText")}{" "}
        <Link
          locale={locale}
          className="underline"
          onClick={onClose}
          href={t("newCustomerFormTermsLink")}
        >
          {t("newCustomerFormTermsLinkText")}
        </Link>
      </p>
    </div>
  );
};
